import { MasterPartnerSettingsDao } from '@db-models/partner-settings.model';

export const PARTNER_SETTINGS_TYPE = {
  PARTNER_ATTRIBUTE: 'partnerAttribute',
  PARTNER_SETTING: 'partnerSetting'
} as const;

export const PARTNER_SETTINGS_INPUT_TYPE = {
  TOGGLE: 'toggle',
  SELECT: 'select',
  INPUT: 'input',
  NUMBER: 'number',
  INPUT_GROUP: 'input-group',
  EMAIL: 'email',
  ANGULAREDITOR: 'angularEditor',
  TAGINPUT: 'tagInput',
  DATE: 'date',
  MULTISELECT: 'multiSelect',
  PASSWORD: 'password'
} as const;

export const WIDGET_APPOINTMENT_TYPE = {
  INTERNAL_APPOINTMENT: 'internal_appointment',
  EXTERNAL_APPOINTMENT: 'external_appointment',
  EXTERNAL_GROUP_APPOINTMENT: 'external_group_appointment',
  EXTERNAL_PRE_DEFINED_SLOTS: 'external_pre_defined_slots',
  EXTERNAL_TOUR: 'external_tour',
};

export const PARTNER_SETTINGS = {
  CUSTOM_EMAIL_SENDER_ADDRESS: 1,
  CUSTOM_SMS_SENDER_NAME: 2,
  LANDINGPAGE_HEADER_BACKGROUND_COLOR: 7,
  LANDINGPAGE_TAB_CONTENT: 11,
  CUSTOM_EMAIL_SENDER_NAME: 14,
  GTM_ANALYTICS_CODE: 16,
  STRIPE_API_KEY: 17,
  IS_ONLINE_PAYMENT_MANDATORY: 18,
  IS_SERVICE_ONLINE_PAYMENT_ENABLED: 19,
  IS_EVENT_ONLINE_PAYMENT_ENABLED: 20,
  WEBHOOK_ENDPOINT: 34,
  WEBHOOK_HEADER_KEY: 35,
  WEBHOOK_HEADER_VALUE: 36,
  SMARTACTION_SATISFACTIONSURVEY_TRIGGER: 48,
  IS_BEXIO_APPOINTMENT_SERVICE_PAYMENT_ENABLED: 49,
  IS_BEXIO_EVENT_PAYMENT_ENABLED: 50,
  BEXIO_DEFAULT_TAX_ID: 51,
  BEXIO_DEFAULT_ACCOUNT_ID: 52,
  BEXIO_DEFAULT_BANK_ACCOUNT_ID: 53,
  BEXIO_ONLY_SYNC_CUSTOMER: 55,
  ONLINE_PAYMENT_SHOW_ON_SITE_PAYMENT_TYPE: 56,
  IS_APPOINTMENT_REBOOKING_DISABLED: 61,
  BEXIO_MWST_TYPE: 62,
  CUSTOM_EMAIL_FOR_CANCELLATIONS: 63,
  DASHBOARD_HIDE_PROGRESS_BAR: 64,
  DASHBOARD_HIDE_UPCOMING_BOOKINGS: 65,
  DASHBOARD_HIDE_STATISTICS: 66,
  DASHBOARD_HIDE_BOOKING_CHART: 67,
  DASHBOARD_HIDE_SHORTCUTS: 68,
  DASHBOARD_HIDE_COMING_SOON: 69,
  DASHBOARD_HIDE_BOOKING_LINK: 70,
  SHOW_STORES_AS_DROPDOWN: 72,
  ONLY_CREATE_APPOINTMENT_WHEN_EVENT_REGISTRATION_EXISTS: 74,
  BEXIO_MWST_IS_NET: 75,
  BEXIO_CONTACT_PERSON_ID: 76,
  OFFER_DELETE_CUSTOMER_DATA_OPTION: 86,
  ENABLE_STORE_POSTCODE_FEATURE: 87,
  LANDINGPAGE_HIDE_RESOURCE: 89,
  LANDINGPAGE_HIDE_SERVICES: 90,
  IS_CANCELLATION_FEATURE_ENABLED: 91,
  DELETE_CUSTOMER_DATA_AFTER_THRESHOLD_ENABLED: 92,
  DELETE_CUSTOMER_DATA_LEADTIME: 93,
  LANDINGPAGE_HIDE_LOCATION: 94,
  LANDINGPAGE_REBOOKING_REASON_IS_OPTIONAL: 97,
  LANDINGPAGE_DEACTIVATE_REBOOKING_REASON: 98,
  WIDGET_ASK_FOR_CUSTOMER_NOTIFICATION: 99,
  WIDGET_DISABLE_AUTOMATIC_SEARCH: 101,
  WIDGET_ENABLE_SERVICES_SEARCH: 102,
  LANDINGPAGE_HIDE_PARTNER_CARD: 105,
  WIDGET_HIDE_RESOURCE_STEP_FOR_DEFAULT_WORKERS: 106,
  WIDGET_APPOINTMENT_SERVICE_CATEGORY_STATUS: 107,
  LANDINGPAGE_ALLOW_REBOOKING_FOR_OTHER_WORKERS: 108,
  LEADTIME_APPOINTMENT_REBOOKING: 109,
  WIDGET_DISABLE_SEARCH_ALL_RESOURCE_BUTTON: 110,
  HIDE_INACTIVE_EVENTS: 111,
  CELL_HEIGHT_IN_CALENDAR: 112,
  CALENDAR_FIRST_HOUR: 113,
  CALENDAR_LAST_HOUR: 114,
  ACTIVATE_PHONE_NUMBER_VERIFICATION_FEATURE: 115,
  INTERNAL_APPOINTMENT_LEAD_TIME: 116,
  WIDGET_EMAIL_REQUIRED: 118,
  WIDGET_EMAIL_SHOWN: 119,
  DASHBOARD_CAN_LOGIN_AS_RESELLER_ADMIN: 120,
  UNBLU_USERNAME: 121,
  UNBLU_PASSWORD: 122,
  UNBLU_API_KEY: 123,
  UNBLU_SERVER_URL: 124,
  GOOGLE_API_KEY: 125,
  AUTOMATIC_STORE_ZIP_SEARCH: 126,
  SHOW_DISTANCE_IN_WIDGET: 127,
  LANDINGPAGE_CANCELLATION_REASON_IS_OPTIONAL: 128,
  LANDINGPAGE_DEACTIVATE_CANCELLATION_REASON: 129,
  INTERNAL_WIDGET_EMAIL_REQUIRED: 130,
  INTERNAL_WIDGET_EMAIL_SHOWN: 131,
  INXMAIL_API_URL: 132,
  INXMAIL_API_ID: 133,
  INXMAIL_API_SECRET: 134,
  ENABLE_QRCODE_FEATURE: 135,
  UNBLU_BASE_SERVER_URL: 136,
  UNBLU_AUTH_TYPE: 138,
  WIDGET_SHOW_INLINE_DESCRIPTION: 139,
  SMSAPI_API_KEY: 140,
  OFFICE365_CLIENT_ID: 141,
  OFFICE365_CLIENT_SECRET: 142,
  OFFICE365_TENANT: 143,
  SHOW_DOWNLOAD_SUMMARY_BUTTON_ON_LANDINGPAGE: 144,
  WIDGET_SHOW_PRIVACY_MESSAGE_CHECKBOX: 145,
  UNBLU_REDIRECT_URL: 148,
  IS_ROUND_ROBIN_FEATURE_ENABLED: 149,
  WIDGET_ONLY_RETURN_FIRST_POSSIBLE_APPOINTMENT: 150,
  MAIL_APPOINTMENT_CUSTOMER_BOOKING: 151,
  MAIL_APPOINTMENT_CUSTOMER_MULTIPLE_BOOKING: 152,
  MAIL_APPOINTMENT_CUSTOMER_REMINDER: 153,
  MAIL_APPOINTMENT_CUSTOMER_REBOOK: 154,
  MAIL_APPOINTMENT_CUSTOMER_CANCEL: 155,
  MAIL_APPOINTMENT_CUSTOMER_CANCEL_SMART_ACTION: 156,
  MAIL_APPOINTMENT_CUSTOMER_AFTER_BOOKING_MESSAGE: 157,
  MAIL_APPOINTMENT_CUSTOMER_BEFORE_BOOKING_MESSAGE: 158,
  MAIL_APPOINTMENT_CUSTOMER_SATISFACTION_SURVEY: 159,
  MAIL_EVENT_CUSTOMER_BOOKING: 160,
  MAIL_EVENT_CUSTOMER_MULTIPLE_BOOKING: 161,
  MAIL_EVENT_CUSTOMER_MULTIDAY_BOOKING: 162,
  MAIL_EVENT_CUSTOMER_CANCEL_BY_CUSTOMER: 163,
  MAIL_EVENT_CUSTOMER_CANCEL_BY_PARTNER: 164,
  MAIL_EVENT_CUSTOMER_WAITINGLIST_CANCEL_BY_PARTNER: 165,
  MAIL_EVENT_CUSTOMER_CANCEL_BY_SMARTACTION: 166,
  MAIL_EVENT_CUSTOMER_WAITINGLIST_SWITCH: 167,
  MAIL_EVENT_CUSTOMER_REMINDER: 168,
  MAIL_EVENT_CUSTOMER_AFTER_BOOKING: 169,
  MAIL_EVENT_CUSTOMER_SATISFACTION_SURVEY: 170,
  MAIL_APPOINTMENT_PARTNER_BOOKING: 171,
  MAIL_APPOINTMENT_PARTNER_BOOKING_MULTIPLE: 172,
  MAIL_APPOINTMENT_PARTNER_REBOOK: 173,
  MAIL_APPOINTMENT_PARTNER_CANCEL: 174,
  MAIL_CUSTOMER_PARTNER_LEAD: 175,
  MAIL_EVENT_PARTNER_BOOKING: 176,
  MAIL_EVENT_PARTNER_BOOKING_MULTIDAY: 177,
  MAIL_EVENT_PARTNER_CANCEL: 178,
  MAIL_EVENT_PARTNER_BOOKING_MULTIPLE: 179,
  MAIL_EVENT_PARTNER_WAITINGLIST_SWITCH: 180,
  MAIL_APPOINTMENT_WORKER_BOOKING: 181,
  MAIL_APPOINTMENT_WORKER_BOOKING_MULTIPLE: 182,
  MAIL_EVENT_WORKER_BOOKING: 183,
  MAIL_EVENT_WORKER_BOOKING_MULTIDAY: 184,
  MAIL_EVENT_WORKER_BOOKING_MULTIPLE: 185,
  EVENT_CREATE_CUSTOMER_PARTICIPATION_APPOINTMENT: 187,
  WIDGET_ADDRESS_REQUIRED: 189,
  WIDGET_CUSTOMER_PROFILES_FEATURE_ENABLED: 190,
  WIDGET_SALUTATION_REQUIRED: 191,
  WIDGET_PHONE_REQUIRED: 192,
  WIDGET_MESSAGE_REQUIRED: 193,
  DEFAULT_MAIL_SENDER: 194,
  SENDINBLUE_API_KEY: 195,
  DEFAULT_SMS_PROVIDER: 197,
  SENDINBLUE_SELECTION_ENABLED: 198,
  EXCHANGE_USE_CUSTOM_AUTH: 199,
  ENABLE_AUTOMATIC_WAITINGLIST_REBOOKING: 203,
  ECALL_USERNAME: 204,
  ECALL_PASSWORD: 205,
  SMARTACTION_EXPORT_APPOINTMENTS: 206,
  SMARTACTION_EXPORT_CUSTOMERS: 207,
  SMARTACTION_EXPORT_GROUP_APPOINTMENTS: 208,
  SMARTACTION_EXPORT_INTERVAL: 209,
  SMARTACTION_EXPORT_RECIPIENT: 210,
  DASHBOARD_HIDE_RATING: 214,
  DEFAULT_VALUE_FOR_CALENDAR_REMINDERS: 215,
  WIDGET_ADOBE_LAUNCH_TRACKING_URL: 217,
  ENABLE_WAITING_TIME_FEATURE: 218,
  DASHBOARD_CUSTOMER_UI_MODE: 219,
  DEACTIVATE_EMAIL_PROVIDER_SELECTION: 220,
  HIDE_CALENDAR_EVENT_TITLE_OF_OTHER_EMPLOYEES: 221,
  HIDE_CONFIGURATION_PROBLEM_BANNER: 222,
  IS_SAFERPAY_ENABLED: 223,
  SAFERPAY_USERNAME: 224,
  SAFERPAY_PASSWORD: 225,
  SAFERPAY_CUSTOMER_ID: 226,
  SAFERPAY_TERMINAL_ID: 227,
  HIDE_BOOK_ADDITIONAL_APPOINTMENT_BUTTON: 229,
  SAFERPAY_API_URL: 230,
  WIDGET_HIDE_EVENT_CAPACITY: 231,
  UNBLU_IDP_ENDPOINT_URL: 232,
  USE_APPOINTMENT_SPECIFIC_CUSTOM_FIELD_VALUES: 233,
  SCROLL_TO_ELEMENT_FEATURE_IS_ENABLED: 234,
  IS_CALDAV_ENABLED: 236,
  WIDGET_INTERNAL_COMMENT_REQUIRED: 237,
  WIDGET_INTERNAL_COMMENT_SHOWN: 238,
  WIDGET_COMPANY_NAME_REQUIRED: 239,
  WIDGET_COMPANY_NAME_SHOWN: 240,
  IS_TEAMS_ENABLED: 241,
  ATTACH_FILES_IN_EXPORT_MAIL: 242,
  IS_STORE_BRANDING_FEATURE_ENABLED: 243,
  SMARTACTION_CUSTOMER_DATA_EXPORT_DURATION: 244,
  SMARTACTION_APPOINTMENT_DATA_EXPORT_DURATION: 245,
  SMARTACTION_GROUP_APPOINTMENT_DATA_EXPORT_DURATION: 246,
  IS_REDIRECT_AFTER_BOOKING_ENABLED: 248,
  SUCCESSFUL_BOOKING_REDIRECT_URL: 249,
  IS_WEBHOOK_ENABLED: 251,
  IS_WIDGET_BANNER_HINT_ENABLED: 252,
  WIDGET_BANNER_HINT_COLOR: 253,
  WIDGET_BANNER_HINT_TEXT: 254,
  IS_APPOINTMENT_STATUS_FEATURE_ENABLED: 255,
  MAIL_APPOINTMENT_STATUS_CUSTOMER_IS_START: 256,
  MAIL_APPOINTMENT_STATUS_CUSTOMER_STATUS_CHANGE: 257,
  MAIL_APPOINTMENT_STATUS_CUSTOMER_IS_CANCELLATION: 258,
  MAIL_APPOINTMENT_STATUS_CUSTOMER_IS_BOOKING_CONFIRMATION: 259,
  MAIL_APPOINTMENT_STATUS_PARTNER_IS_START: 260,
  MAIL_APPOINTMENT_STATUS_PARTNER_STATUS_CHANGE: 261,
  MAIL_APPOINTMENT_STATUS_PARTNER_IS_CANCELLATION: 262,
  MAIL_APPOINTMENT_STATUS_PARTNER_IS_BOOKING_CONFIRMATION: 263,
  IS_BLOCK_OTHER_RESOURCE_FEATURE_ENABLED: 264,
  BLOCK_OTHER_RESOURCE_MODE: 265,
  BOOKING_PAGE_BORDER_RADIUS: 267,
  BOOKING_PAGE_BOX_SHADOW: 268,
  ANYONE_FEATURE_HIDE_RESSOURCE: 269,
  BOOKING_PAGE_PRIMARY_COLOR: 274,
  BOOKING_PAGE_BACKGROUND_COLOR: 275,
  BOOKING_PAGE_HIDE_APPOINTMENT_TAB: 276,
  BOOKING_PAGE_HIDE_EVENT_TAB: 277,
  BOOKING_PAGE_HIDE_EMPLOYEE_TAB: 278,
  BOOKING_PAGE_HIDE_STORE_TAB: 279,
  BOOKING_PAGE_HIDE_ABOUT_US_TAB: 280,
  BOOKING_PAGE_HIDE_RATINGS_TAB: 281,
  DASHBOARD_HIDE_SETUP_ASSISTANT: 282,
  IS_DISPLAY_TIMES_IN_CALENDAR_ENABLED: 283,
  BOOK_ANOTHER_APPOINTMENT_URL: 284,
  WIDGET_TITLE_REQUIRED: 285,
  WIDGET_TITLE_SHOWN: 286,
  WIDGET_COUNTRY_REQUIRED: 287,
  WIDGET_COUNTRY_SHOWN: 288,
  WEBHOOK_STRIP_HTML_TAGS: 289,
  WIDGET_SHOW_RESOURCE_STORE_NAME: 290,
  IS_CAPTCHA_FEATURE_ENABLED: 291,
  NUMBER_OF_RESOURCES_IN_CALENDAR: 292,
  INFORM_EMPLOYEES_ABOUT_CALENDAR_SYNCHRONIZATION_PROBLEMS: 293,
  CALENDAR_SYNCHRONIZATION_PROBLEMS_RECIPIENTS: 294,
  IGNORE_WORKERS_WITHOUT_CALENDAR: 295,
  IS_LEXOFFICE_ENABLED: 296,
  LEXOFFICE_API_KEY: 297,
  BLOCK_ACCESS_FOR_SUPPORTUSER: 298,
  REQUIRED_APPOINTMENT_FORM_FIELDS: 299,
  REQUIRED_CUSTOMER_FORM_FIELDS: 300,
  IS_GROUP_APPOINTMENT_CATEGORY_FEATURE_ENABLED: 301,
  IS_GROUP_APPOINTMENT_STORE_FEATURE_ENABLED: 302,
  SALESFORCE_AUTH_URL: 303,
  SALESFORCE_CLIENT_ID: 304,
  SALESFORCE_CLIENT_SECRET: 305,
  SALESFORCE_USERNAME: 306,
  SALESFORCE_PASSWORD: 307,
  SALESFORCE_API_URL: 308,
  IS_SALESFORCE_ENABLED: 309,
  IS_LDAP_SSO_ENABLED: 310,
  LDAP_HOST: 311,
  LDAP_DN: 312,
  LDAP_PASSWORD: 313,
  LDAP_SEARCH_BASE: 314,
  WIDGET_MOBILE_REQUIRED: 315,
  WIDGET_LANGUAGE_POLISH_HIDDEN: 316,
  SHOW_MOBILE_ON_WIDGET: 317,
  ACTIVATE_MOBILE_NUMBER_VERIFICATION_FEATURE: 318,
  IS_WIDGET_EVENT_SINGLE_SLOT_PRESELECT_ENABLED: 319,
  GROUP_APPOINTMENTS_FILTER_BEHAVIOUR: 320,
  WIDGET_LANGUAGE_SWEDISH_HIDDEN: 321,
  WIDGET_LANGUAGE_SPANISH_HIDDEN: 322,
  SHOW_PHONE_ON_WIDGET: 324,
  IS_EXIVO_ENABLED: 325,
  EXIVO_API_KEY: 326,
  EXIVO_API_SECRET: 327,
  // Renamed for Booking Limits (JB-208)
  IS_GLOBAL_EMPLOYEE_BOOKING_LIMIT_ENABLED: 328,
  GLOBAL_EMPLOYEE_BOOKING_LIMIT: 329,
  // Legacy aliases - keep for backward compatibility
  IS_APPOINTMENT_LIMIT_PER_EMPLOYEE_ENABLED: 328,
  APPOINTMENT_LIMIT_PER_EMPLOYEE: 329,
  IS_WIDGET_SERVICE_SHORTCUT_BUTTON_ENABLED: 330,
  AZURE_AD_CLIENT_ID: 331,
  WIDGET_IS_APPOINTMENT_SERVICE_ARROW_ENABLED: 332,
  WHITELISTED_IP_ADDRESSES: 333,
  IS_CALENDLY_ENABLED: 334,
  CALENDLY_CLIENT_ID: 386,
  CALENDLY_CLIENT_SECRET: 387,
  SHOW_POSTCODE_RESULT_AS_STORE_OR_CITIES: 336,
  IS_EVENT_REBOOKING_ENABLED: 337,
  IS_EVENT_REBOOKING_REASON_OPTIONAL: 338,
  IS_EVENT_REBOOKING_REASON_ENABLED: 339,
  IS_EVENT_BOOKING_LIMIT_ENABLED: 342,
  GLOBAL_EVENT_BOOKING_LIMIT: 343,
  MAIL_EVENT_BOOKING_REACHED: 344,
  WIDGET_SHOW_FREE_SLOTS_IN_OVERVIEW: 345,
  BOOKING_PAGE_HIDE_PARTNER_ADDRESS: 346,
  BOOKING_PAGE_UI_MODE: 347,
  BOOKING_PAGE_HIDE_SWITCHER: 348,
  SHOW_MOBILE_OF_WORKER_ON_LANDINGPAGE: 349,
  AZURE_AD_CLIENT_SECRET: 350,
  AZURE_AD_TENANT_ID: 351,
  OFFICE365_CLIENT_SECRET_EXPIRY: 352,
  INXMAIL_API_SECRET_EXPIRY: 353,
  AZURE_AD_CLIENT_SECRET_EXPIRY: 356,
  LOAD_EXTERNAL_CALENDAR_AVAILABILITIES: 357,
  WIDGET_SHOW_LOCATION_ON_APPOINTMENT_PROPOSAL: 359,
  SHOW_WORKER_SELECTION_ON_DATE_STEP: 360,
  IS_AVAILABILITY_AND_ABSENCE_VIEW_IN_CALENDAR_ENABLED: 363,
  SHOW_WIDGET_SLOT_LOCATION: 364,
  WIDGET_REMOVE_DUPLICATE_MINUTES_SLOTS: 365,
  USE_NEW_DASHBOARD_DESIGN: 366,
  IS_WORKFLOW_ENABLED: 367,
  USE_CUSTOM_EMAIL_TEMPLATE: 368,
  SEND_EMAIL_FROM_TEST_SYSTEMS: 369,
  DEFAULT_EMAIL_PROVIDER: 370,
  SMTP_HOST: 371,
  SMTP_PORT: 372,
  SMTP_USERNAME: 373,
  SMTP_PASSWORD: 374,
  SMTP_TLS: 375,
  WIDGET_JUMPS_TO_RESOURCES_STEP_WHEN_SINGLE_SERVICE: 376,
  IS_AZURE_SYNC_ENABLED: 378,
  IS_AUTO_REFRESH_ENABLED: 384,
  AUTO_REFRESH_INTERVAL: 385,
  SPLIT_PERSONAL_FORM_AND_SUMMARY_IN_WIDGET: 388,
  IS_APPOINTMENT_RESERVATION_ENABLED: 389,
  X_MINUTES_APPOINTMENT_RESERVATION: 390,
  SHOW_WORKER_SELECTION_ON_DATE_STEP_ON_LANDING_PAGE: 391,
  SWISSCOM_API_KEY: 392,
  SHOW_CROSS_SELLING_SERVICES_ON_SUMMARY_STEP: 393,
  MAIL_EVENT_REGISTRATION_GUEST: 394,
  MAIL_EVENT_CANCEL_GUEST: 395,
  IS_WIDGET_ANYONE_EXCEPTION_ENABLED: 396,
  IS_LOGIN_USING_EMAIL_DISABLED: 397,
  SHOW_WIDGET_CALENDAR_NOTICE: 398,
  HIDE_EXTERNAL_CALENDAR_EVENTS_IN_CALENDAR: 399,
  IS_WIDGET_PASSWORD_PROTECTION_SETTING_ENABLED: 400,
  PARTNER_WIDGET_ACCESS_PASSWORD: 401,
  WIDGET_TYPE_PREFERENCES: 402,
  BATCH_REQUEST_FOR_OFFICE365: 403,
  REDIRECT_AFTER_BOOKING_ACTION: 404,
  ACTIVATE_CALENDAR_REMINDERS: 405,
  SHOW_UNIQUE_STORES_BASED_ON_POSTAL_CODE_MAPPINGS: 407,
  WIDGET_BIRTHDAY_SHOWN: 408,
  WIDGET_BIRTHDAY_REQUIRED: 409,
  WIDGET_BIRTHDAY_MINIMUM_AGE_18: 410,
  MAX_APPOINTMENT_REBOOKING_LIMIT: 411,
  WIDGET_VAT_TYPE: 412,
  ENABLE_PHISHING_PROTECTION: 413,
  PHISHING_PROTECTION_REGEX: 414,
  RESERVED_CALENDAR_WITH_APPOINTMENT_STATUS_FEATURE: 415,
  CAPTCHA_TYPE: 416,
  FRIENDLY_CAPTCHA_SITEKEY: 417,
  FRIENDLY_CAPTCHA_APIKEY: 418,
  WIDGET_PROTECTION_TYPE: 419,
  OTP_VERIFICATION_TYPE: 420,
  OTP_COMPLEXITY: 421,
  IS_CUSTOMER_AUTHENTICATION_ENABLED: 422,
  ENABLE_WIDGET_RESTRICTION: 423,
  WIDGET_RESTRICTION_PARAMETERS: 424,
  ENABLE_WORKERS_RANDOMIZE_WITH_SAME_TIME_SLOTS: 425,
  ENABLE_CUSTOMER_BOOKING_EXPORT: 426,
  IFRAME_RESIZER_VERSION: 427,
  ICS_FILE_ORGANIZER_NAME: 428,
  ICS_FILE_ORGANIZER_EMAIL: 429,
  SMS_APPOINTMENT_CUSTOMER_BOOKING: 430,
  SMS_APPOINTMENT_CUSTOMER_MULTIPLE_BOOKING: 431,
  SMS_APPOINTMENT_CUSTOMER_REMINDER: 432,
  SMS_EVENT_CUSTOMER_BOOKING: 433,
  SMS_EVENT_CUSTOMER_MULTIPLE_BOOKING: 434,
  SMS_EVENT_CUSTOMER_CANCEL_BY_PARTNER: 435,
  SMS_EVENT_CUSTOMER_SIGNOFF: 436,
  SMS_EVENT_CUSTOMER_CANCEL_BY_CUSTOMER: 437,
  SMS_EVENT_CUSTOMER_REMINDER: 438, SMS_EVENT_CUSTOMER_WAITINGLIST_SWITCH: 439,
  SMS_EVENT_CUSTOMER_WAITINGLIST_REGISTRATION: 440,
  SMS_EVENT_PARTNER_BOOKING: 441,
  SMS_EVENT_CUSTOMER_MULTIDAY_BOOKING: 442,
  SMS_APPOINTMENT_CUSTOMER_REBOOK: 443,
  SMS_EVENT_CUSTOMER_WAITINGLIST_CANCEL_BY_PARTNER: 444,
  SMS_EVENT_PARTNER_REBOOK: 445,
  SMS_CUSTOMER_PARTNER_LEAD: 446,
  CALENDAR_WEEK_START_DAY: 447,
  CALENDAR_DEFAULT_VIEW: 448,
  CUSTOMER_AUTHENTICATION_URL: 449,
  IS_GLOBAL_SERVICE_BOOKING_LIMIT_ENABLED: 450,
  GLOBAL_SERVICE_LIMIT_DURATION: 451,
  GLOBAL_SERVICE_BOOKING_LIMIT: 452,
  GLOBAL_EMPLOYEE_LIMIT_DURATION: 453,
  // Microsoft Teams Meeting Settings (IDs 454-462)
  TEAMS_LOBBY_BYPASS_SCOPE: 454,
  TEAMS_DIAL_IN_BYPASS_ENABLED: 455,
  TEAMS_ALLOWED_LOBBY_ADMITTERS: 456,
  TEAMS_ENTRY_EXIT_ANNOUNCED: 457,
  TEAMS_ALLOWED_PRESENTERS: 458,
  TEAMS_ALLOW_ATTENDEE_MIC: 459,
  TEAMS_ALLOW_ATTENDEE_CAMERA: 460,
  TEAMS_ALLOW_MEETING_CHAT: 461,
  TEAMS_ALLOW_REACTIONS: 462,
  OBFUSCATE_CUSTOMER_DATA_ON_LANDINGPAGES: 463,
  MAIL_RESOURCE_PLANNING_WORKER_ASSIGNED: 464,
  MAIL_RESOURCE_PLANNING_WORKER_UNASSIGNED: 465,
  MAIL_RESOURCE_PLANNING_FULLY_STAFFED: 466,
  MAIL_RESOURCE_PLANNING_STAFFING_REMINDER: 467,
  RESOURCE_PLANNING_STAFFING_REMINDER_DAYS: 468,
  APPOINTMENT_LIST_COLUMNS: 469,
  // Dynamic Combi Services (Tour Configuration)
  IS_DYNAMIC_COMBI_ENABLED: 470,
  DYNAMIC_COMBI_MAX_DURATION_MINUTES: 471,
  DYNAMIC_COMBI_TRAVEL_TIME_MODE: 472,
  // HubSpot Integration Settings (IDs 473-479)
  IS_HUBSPOT_ENABLED: 473,
  HUBSPOT_CLIENT_ID: 474,
  HUBSPOT_CLIENT_SECRET: 475,
  HUBSPOT_SYNC_CONTACTS: 476,
  HUBSPOT_SYNC_COMPANIES: 477,
  HUBSPOT_SYNC_APPOINTMENTS: 478,
  HUBSPOT_DEFAULT_OWNER_ID: 479,
  MAIL_RESOURCE_PLANNING_UNBOOKED_REMINDER: 480,
  MS_GRAPH_EMAIL_SENDER_ADDRESS: 484,
  MS_GRAPH_TENANT_ID: 485,
  MS_GRAPH_CLIENT_ID: 486,
  MS_GRAPH_CLIENT_SECRET: 487,
  MS_GRAPH_CLIENT_SECRET_EXPIRY: 488,
  USE_NATIVE_TEAMS_CALENDAR_EVENT: 489,
  WEBEX_ENABLED_JOIN_BEFORE_HOST: 490,
  WEBEX_JOIN_BEFORE_HOST_MINUTES: 491,
  WEBEX_ENABLE_CONNECT_AUDIO_BEFORE_HOST: 492,
  WEBEX_ALLOW_ANY_USER_TO_BE_CO_HOST: 493,
  WEBEX_ALLOW_FIRST_USER_TO_BE_CO_HOST: 494,
  WEBEX_ENABLED_AUTO_RECORD_MEETING: 495,
  WEBEX_SEND_EMAIL: 496,
  CUSTOMER_LIST_COLUMNS: 497,
  IS_WAITINGLIST_AUTO_REFUND_ENABLED: 498,
  IS_GRAPH_API_LOGGING_ENABLED: 499,
  OTP_RESTRICTED_COMPONENTS: 500,
  ICS_FILE_ADD_ATTENDEE: 501,
  ICS_FILE_METHOD: 502,
  IS_STRIPE_APPOINTMENT_PAYMENT_ENABLED: 503,
  IS_STRIPE_EVENT_PAYMENT_ENABLED: 504,
  WIDGET_TIME_FORMAT: 505,
  IS_ZIP_CODES_SEARCH_ENABLED: 506,
  IS_GTM_ENABLED: 507,
  TOUR_UPCOMING_ABSENCES_WINDOW_DAYS: 508,
  CROSS_SELLING_SERVICES_CATEGORY_FILTER: 509,
  WIDGET_DISPLAY_TIMEZONE_SOURCE: 511,
  TWILIO_ACCOUNT_SID: 519,
  TWILIO_AUTH_TOKEN: 520,
  TWILIO_FROM_NUMBER: 521,
  SENDGRID_API_KEY: 522,
  SENDGRID_WEBHOOK_VERIFICATION_KEY: 523,
  AZURE_SSO_LOGIN_IDENTIFIER: 526,
  // Queue Module — shifted to 543+ to avoid collision with twilio/sendgrid 519-523.
  // Backend migrations must match these IDs.
  QUEUE_SLA_TARGET_SECONDS: 543,
  QUEUE_SLA_MAX_SECONDS: 544,
  QUEUE_RETENTION_DAYS: 545,
  QUEUE_MODE: 546,
  // IDs 547-553 reserved for the legacy queue notification toggles
  // (queue_notifications_enabled / queue_sms_* / queue_email_*). Replaced by the
  // workflow-based pipeline — partners configure SMS / email behaviour through
  // /app/workflows now. Constants intentionally removed so the dashboard
  // can no longer reference them; the master rows in the DB are dropped
  // in the Phase D migration.
  QUEUE_KIOSK_CAPTURE_PHONE: 554,
  QUEUE_KIOSK_CONSENT_TEXT_KEY: 555,
  QUEUE_QR_TARGET: 556,
  QUEUE_QR_SHOW_ON_PRINT: 557,
  QUEUE_QR_SHOW_ON_SCREEN: 558,
  QUEUE_APPT_AUTO_ENROLL: 559,
  QUEUE_APPT_ENROLL_WINDOW_MINUTES: 560,
  QUEUE_APPT_REQUIRE_CHECKIN: 561,
  QUEUE_APPT_INHERIT_CUSTOMER_DATA: 562,
  // Wave 3 — SLA Compliance & Analytics
  QUEUE_SLA_SERVICE_TARGET_SECONDS: 563,
  QUEUE_SLA_SERVICE_MAX_SECONDS: 564,
  QUEUE_SLA_RECALL_TARGET_SECONDS: 565,
  QUEUE_SLA_RECALL_MAX_SECONDS: 566,
  QUEUE_SLA_HELP_DISMISSED: 567,
  ENABLE_ROUND_ROBIN_V2: 568,
  ROUND_ROBIN_DEFAULT_ALGORITHM: 569,
  ROUND_ROBIN_APPLY_ON_REBOOKING: 570,
  ROUND_ROBIN_V2_CHANNEL_SCOPE: 571,
  WIDGET_BUTTONS_ALWAYS_ENABLED: 572,
  MEETING_TYPE_SELECTION_UI_MODE: 573,
  ENABLE_MULTI_STORE_WORKERS: 574,
  MARK_ON_SITE_APPOINTMENT_PAID_BY_DEFAULT: 575,
  ICS_FILE_EMPLOYEE_METHOD: 576,
  BOOKING_PAGE_HIDE_FROM_SEARCH_ENGINES: 577,
  IS_SCIM_ENABLED: 578,
  // 578 is claimed by the SCIM provisioning ticket; this one is 579.
  FORECAST_ABSENCE_KEYWORDS: 579,
  // 580-582 are claimed by in-flight branches (widget_worker_unavailable_html,
  // enable_store_availabilities, the Adyen settings); this one is 583.
  DEFAULT_PAYMENT_TYPE: 583,
  // 584 is claimed by JB-648/JB-720/JB-966; this one is 585.
  IS_AZURE_SYNC_TEAMS_AUTO_CONNECT_ENABLED: 585,
  // 586-588: block rebooking/cancellation for admins/consultants.
  IS_ADMIN_APPOINTMENT_REBOOKING_DISABLED: 586,
  IS_ADMIN_EVENT_REBOOKING_DISABLED: 587,
  IS_ADMIN_CANCELLATION_DISABLED: 588,
  // 586-588 went to JB-1803, so this one is 589. Must match the cakephp SettingsSeed row
  // exactly -- partners_settings has no FK, so the id is the durable link to a partner's
  // stored value.
  ENABLE_STORE_HIERARCHY: 589,
  IS_EXTERNAL_INVOICE_APPOINTMENT_PAYMENT_ENABLED: 590,
  // kMeet room options are 591-596.
  KMEET_START_AUDIO_MUTED: 591,
  KMEET_START_AUDIO_ONLY: 592,
  KMEET_ENABLE_MODERATOR_VIDEO: 593,
  KMEET_LOBBY_ENABLED: 594,
  KMEET_PASSWORD_ENABLED: 595,
  KMEET_E2EE_ENABLED: 596,
  IS_AZURE_SSO_MAPPED_GROUP_REQUIRED: 606,
};

export const MASTER_PARTNER_SETTINGS: MasterPartnerSettingsDao = {
  1: {
    id: 1,
    key: 'custom_email_sender_address',
    default_value: 'info@calenso.com',
    category: 'whitelabel',
    type: 'string',
    requires_verification: 1
  },
  2: {
    id: 2,
    key: 'custom_sms_sender_name',
    default_value: 'CALENSO',
    category: 'whitelabel',
    type: 'string',
    requires_verification: 1
  },
  7: {
    id: 7,
    key: 'landingpage_header_background_color',
    default_value: '#FFFFFF',
    category: 'landingpage',
    type: 'string',
  },
  11: {
    id: 11,
    key: 'landingpage_tab_content',
    default_value: '#FFFFFF',
    category: 'landingpage',
    type: 'string',
  },
  14: {
    id: 14,
    key: 'custom_email_sender_name',
    default_value: 'Calenso',
    category: 'whitelabel',
    type: 'string',
    requires_verification: 1
  },
  16: {
    id: 16,
    key: 'gtm_analytics_code',
    default_value: null,
    category: 'analytics-integration',
    type: 'string',
  },
  17: {
    id: 17,
    key: 'stripe_api_key',
    default_value: null, // pk_live_xxxxxxxxxxxxxxxxxxxxx
    category: 'stripe',
    type: 'string',
  },
  18: {
    id: 18,
    key: 'is_online_payment_mandatory',
    default_value: 0,
    category: 'stripe',
    type: 'boolean',
  },
  19: {
    id: 19,
    key: 'is_service_online_payment_enabled',
    default_value: 0,
    category: 'stripe',
    type: 'boolean',
  },
  20: {
    id: 20,
    key: 'is_event_online_payment_enabled',
    default_value: 0,
    category: 'stripe',
    type: 'boolean',
  },
  34: {
    id: 34,
    key: 'webhook_endpoint',
    default_value: null,
    category: 'webhook',
    type: 'string',
  },
  35: {
    id: 35,
    key: 'webhook_header_key',
    default_value: null, // Authorization
    category: 'webhook',
    type: 'string',
  },
  36: {
    id: 36,
    key: 'webhook_header_value',
    default_value: null, // Bearer ....
    category: 'webhook',
    type: 'string',
  },
  48: {
    id: 48,
    key: 'smartaction_satisfactionsurvey_trigger',
    default_value: 1,
    category: 'smartaction',
    type: 'int',
  },
  49: {
    id: 49,
    key: 'is_bexio_appointment_service_payment_enabled',
    default_value: 0,
    category: 'bexio',
    type: 'boolean',
  },
  50: {
    id: 50,
    key: 'is_bexio_event_payment_enabled',
    default_value: 0,
    category: 'bexio',
    type: 'boolean',
  },
  51: {
    id: 51,
    key: 'bexio_default_tax_id',
    default_value: null,
    category: 'bexio',
    type: 'int',
  },
  52: {
    id: 52,
    key: 'bexio_default_account_id',
    default_value: null,
    category: 'bexio',
    type: 'int',
  },
  53: {
    id: 53,
    key: 'bexio_default_bank_account_id',
    default_value: null,
    category: 'bexio',
    type: 'int',
  },
  55: {
    id: 55,
    key: 'bexio_only_sync_customer',
    default_value: 0, // Example
    category: 'bexio',
    type: 'int',
  },
  56: {
    id: 56,
    key: 'online_payment_show_on_site_payment_type',
    default_value: 1, // Example
    category: 'online_payment',
    type: 'int',
  },
  61: {
    id: 61,
    key: 'is_appointment_rebooking_disabled',
    default_value: '0',
    category: 'appointment',
    type: 'boolean',
  },
  62: {
    id: 62,
    key: 'bexio_mwst_type',
    default_value: '0',
    category: 'bexio',
    type: 'int',
  },
  63: {
    id: 63,
    key: 'custom_email_for_cancellations',
    default_value: '',
    category: 'notification',
    type: 'string',
  },
  64: {
    id: 64,
    key: 'dashboard_hide_progress_bar',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  65: {
    id: 65,
    key: 'dashboard_hide_upcoming_bookings',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  66: {
    id: 66,
    key: 'dashboard_hide_statistics',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  67: {
    id: 67,
    key: 'dashboard_hide_booking_chart',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  68: {
    id: 68,
    key: 'dashboard_hide_shortcuts',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  69: {
    id: 69,
    key: 'dashboard_hide_coming_soon',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  70: {
    id: 70,
    key: 'dashboard_hide_booking_link',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  72: {
    id: 72,
    key: 'show_stores_as_dropdown',
    default_value: '0',
    category: 'widget',
    type: 'boolean'
  },
  74: {
    id: 74,
    key: 'only_create_appointment_when_event_registration_exists',
    default_value: '0',
    category: 'events',
    type: 'boolean',
  },
  75: {
    id: 75,
    key: 'bexio_mwst_is_net',
    default_value: '0',
    category: 'bexio',
    type: 'boolean',
  },
  76: {
    id: 76,
    key: 'bexio_contact_person_id',
    default_value: '0',
    category: 'bexio',
    type: 'int',
  },
  86: {
    id: 86,
    key: 'offer_delete_customer_data_option',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  87: {
    id: 87,
    key: 'enable_store_postcode_feature',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  89: {
    id: 89,
    key: 'landingpage_hide_resource',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  90: {
    id: 90,
    key: 'landingpage_hide_services',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  91: {
    id: 91,
    key: 'is_cancellation_feature_enabled',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  92: {
    id: 92,
    key: 'delete_customer_data_after_threshold_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  93: {
    id: 93,
    key: 'delete_customer_data_leadtime', // in days
    default_value: 30,
    category: 'setting',
    type: 'int',
  },
  94: {
    id: 94,
    key: 'landingpage_hide_location',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  97: {
    id: 97,
    key: 'landingpage_rebooking_reason_is_optional',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  98: {
    id: 98,
    key: 'landingpage_deactivate_rebooking_reason',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  99: {
    id: 99,
    key: 'widget_ask_for_customer_notification',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  101: {
    id: 101,
    key: 'widget_disable_automatic_search',
    default_value: 0,
    category: 'widget',
    type: 'boolean',
  },
  102: {
    id: 102,
    key: 'widget_enable_services_search',
    default_value: 0,
    category: 'widget',
    type: 'boolean',
  },
  105: {
    id: 105,
    key: 'landingpage_hide_partner_card',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  106: {
    id: 106,
    key: 'widget_hide_resource_step_for_default_workers',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  // 0: all collapsed
  // 1: first open
  // 2: all open
  107: {
    id: 107,
    key: 'widget_appointment_service_category_status',
    default_value: 1,
    category: 'setting',
    type: 'int',
  },
  108: {
    id: 108,
    key: 'landingpage_allow_rebooking_for_other_workers',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  109: {
    id: 109,
    key: 'leadtime_appointment_rebooking',
    default_value: 24,
    category: 'setting',
    type: 'int',
  },
  110: {
    id: 110,
    key: 'widget_disable_search_all_resource_button',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  111: {
    id: 111,
    key: 'hide_inactive_events',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  112: {
    id: 112,
    key: 'cell_height_in_calendar',
    default_value: 100,
    category: 'setting',
    type: 'int',
  },
  113: {
    id: 113,
    key: 'calendar_first_hour',
    default_value: 6,
    category: 'setting',
    type: 'int',
  },
  114: {
    id: 114,
    key: 'calendar_last_hour',
    default_value: 22,
    category: 'setting',
    type: 'int',
  },
  115: {
    id: 115,
    key: 'activate_phone_number_verification_feature',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  116: {
    id: 116,
    key: 'internal_appointment_lead_time',
    default_value: 24,
    category: 'setting',
    type: 'int',
  },
  118: {
    id: 118,
    key: 'widget_email_required',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  119: {
    id: 119,
    key: 'widget_email_shown',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  120: {
    id: 120,
    key: 'dashboard_can_login_as_reseller_admin',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  121: {
    id: 121,
    key: 'unblu_username',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  122: {
    id: 122,
    key: 'unblu_password',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  123: {
    id: 123,
    key: 'unblu_api_key',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  124: {
    id: 124,
    key: 'unblu_server_url',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  125: {
    id: 125,
    key: 'google_api_key',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  126: {
    id: 126,
    key: 'automatic_store_zip_search',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  127: {
    id: 127,
    key: 'show_distance_in_widget',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  128: {
    id: 128,
    key: 'landingpage_cancellation_reason_is_optional',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  129: {
    id: 129,
    key: 'landingpage_deactivate_cancellation_reason',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  130: {
    id: 130,
    key: 'internal_widget_email_required',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  131: {
    id: 131,
    key: 'internal_widget_email_shown',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  132: {
    id: 132,
    key: 'inxmail_api_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  133: {
    id: 133,
    key: 'inxmail_api_id',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  134: {
    id: 134,
    key: 'inxmail_api_secret',
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  135: {
    id: 135,
    key: 'enable_qrcode_feature',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  136: {
    id: 136,
    key: 'unblu_base_server_url', // https://unblu.cloud
    default_value: null,
    category: 'setting',
    type: 'int'
  },
  138: {
    id: 138,
    key: 'unblu_auth_type',
    default_value: 'basic',
    category: 'setting',
    type: 'string'
  },
  139: {
    id: 139,
    key: 'widget_show_inline_description',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  140: {
    id: 140,
    key: 'smsapi_api_key',
    default_value: null,
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  141: {
    id: 141,
    key: 'office365_client_id',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  142: {
    id: 142,
    key: 'office365_client_secret',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  143: {
    id: 143,
    key: 'office365_tenant',
    default_value: 'common',
    category: 'setting',
    type: 'string'
  },
  144: {
    id: 144,
    key: 'show_download_summary_button_on_landingpage',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  145: {
    id: 145,
    key: 'widget_show_privacy_message_checkbox',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  148: {
    id: 148,
    key: 'unblu_redirect_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  149: {
    id: 149,
    key: 'is_round_robin_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  150: {
    id: 150,
    key: 'widget_only_return_first_possible_appointment',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  // mail send settings
  151: {
    id: 151,
    key: 'mail_appointment_customer_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  152: {
    id: 152,
    key: 'mail_appointment_customer_multiple_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  153: {
    id: 153,
    key: 'mail_appointment_customer_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  154: {
    id: 154,
    key: 'mail_appointment_customer_rebook',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  155: {
    id: 155,
    key: 'mail_appointment_customer_cancel',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  156: {
    id: 156,
    key: 'mail_appointment_customer_cancel_smart_action',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  157: {
    id: 157,
    key: 'mail_appointment_customer_after_booking_message',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  158: {
    id: 158,
    key: 'mail_appointment_customer_before_booking_message',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  159: {
    id: 159,
    key: 'mail_appointment_customer_satisfaction_survey',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  160: {
    id: 160,
    key: 'mail_event_customer_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  161: {
    id: 161,
    key: 'mail_event_customer_multiple_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  162: {
    id: 162,
    key: 'mail_event_customer_multiday_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  163: {
    id: 163,
    key: 'mail_event_customer_cancel_by_customer',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  164: {
    id: 164,
    key: 'mail_event_customer_cancel_by_partner',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  165: {
    id: 165,
    key: 'mail_event_customer_waitinglist_cancel_by_partner',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  166: {
    id: 166,
    key: 'mail_event_customer_cancel_by_smartaction',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  167: {
    id: 167,
    key: 'mail_event_customer_waitinglist_switch',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  168: {
    id: 168,
    key: 'mail_event_customer_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  169: {
    id: 169,
    key: 'mail_event_customer_after_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  170: {
    id: 170,
    key: 'mail_event_customer_satisfaction_survey',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  // partner
  171: {
    id: 171,
    key: 'mail_appointment_partner_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  172: {
    id: 172,
    key: 'mail_appointment_partner_booking_multiple',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  173: {
    id: 173,
    key: 'mail_appointment_partner_rebook',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  174: {
    id: 174,
    key: 'mail_appointment_partner_cancel',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  175: {
    id: 175,
    key: 'mail_customer_partner_lead',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  176: {
    id: 176,
    key: 'mail_event_partner_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  177: {
    id: 177,
    key: 'mail_event_partner_booking_multiday',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  178: {
    id: 178,
    key: 'mail_event_partner_cancel',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  179: {
    id: 179,
    key: 'mail_event_partner_booking_multiple',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  180: {
    id: 180,
    key: 'mail_event_partner_waitinglist_switch',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  // worker
  181: {
    id: 181,
    key: 'mail_appointment_worker_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  182: {
    id: 182,
    key: 'mail_appointment_worker_booking_multiple',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  183: {
    id: 183,
    key: 'mail_event_worker_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  184: {
    id: 184,
    key: 'mail_event_worker_booking_multiday',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  185: {
    id: 185,
    key: 'mail_event_worker_booking_multiple',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  187: {
    id: 187,
    key: 'event_create_customer_participation_appointment',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  189: {
    id: 189,
    key: 'widget_address_required',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  190: {
    id: 190,
    key: 'widget_customer_profiles_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  191: {
    id: 191,
    key: 'widget_salutation_required',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  192: {
    id: 192,
    key: 'widget_phone_required',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  193: {
    id: 193,
    key: 'widget_message_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  194: {
    id: 194,
    key: 'default_mail_sender',
    default_value: 'sendgrid', // sendgrid, Brevo, mailtrap
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  195: {
    id: 195,
    key: 'sendinblue_api_key',
    default_value: null,
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  197: {
    id: 197,
    key: 'default_sms_provider',
    default_value: 'smsapi',
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  198: {
    id: 198,
    key: 'sendinblue_selection_enabled',
    default_value: '0',
    category: 'setting',
    type: 'int'
  },
  // sanitas certificate request per exchange
  199: {
    id: 199,
    key: 'exchange_use_custom_auth',
    default_value: '0',
    category: 'setting',
    type: 'int'
  },
  203: {
    id: 203,
    key: 'enable_automatic_waitinglist_rebooking',
    default_value: '1',
    category: 'setting',
    type: 'int'
  },
  204: {
    id: 204,
    key: 'ecall_username',
    default_value: null,
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  205: {
    id: 205,
    key: 'ecall_password',
    default_value: null,
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  // smartaction export
  206: {
    id: 206,
    key: 'smartaction_export_appointments',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  207: {
    id: 207,
    key: 'smartaction_export_customers',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  208: {
    id: 208,
    key: 'smartaction_export_group_appointments',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  209: {
    id: 209,
    key: 'smartaction_export_interval',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  210: {
    id: 210,
    key: 'smartaction_export_recipient',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  214: {
    id: 214,
    key: 'dashboard_hide_rating',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  215: {
    id: 215,
    key: 'default_value_for_calendar_reminders',
    default_value: 15,
    category: 'setting',
    type: 'int',
  },
  217: {
    id: 217,
    key: 'widget_adobe_launch_tracking_url',
    default_value: null,
    category: 'analytics-integration',
    type: 'string',
  },
  218: {
    id: 218,
    key: 'enable_waiting_time_feature',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  219: {
    id: 219,
    key: 'dashboard_customer_ui_mode',
    default_value: 'list',
    category: 'dashboard',
    type: 'string',
  },
  220: {
    id: 220,
    key: 'deactivate_email_provider_selection',
    default_value: 0,
    category: 'dashboard',
    type: 'boolean',
  },
  221: {
    id: 221,
    key: 'hide_calendar_event_title_of_other_employees',
    default_value: 0,
    category: 'dashboard',
    type: 'boolean',
  },
  222: {
    id: 222,
    key: 'hide_configuration_problem_banner',
    default_value: 0,
    category: 'dashboard',
    type: 'boolean',
  },
  // saferpay
  223: {
    id: 223,
    key: 'is_saferpay_enabled',
    default_value: 0,
    category: 'payment',
    type: 'boolean',
  },
  224: {
    id: 224,
    key: 'saferpay_username',
    default_value: null,
    category: 'payment',
    type: 'string',
  },
  225: {
    id: 225,
    key: 'saferpay_password',
    default_value: null,
    category: 'payment',
    type: 'string',
  },
  226: {
    id: 226,
    key: 'saferpay_customer_id',
    default_value: null,
    category: 'payment',
    type: 'string',
  },
  227: {
    id: 227,
    key: 'saferpay_terminal_id',
    default_value: null,
    category: 'payment',
    type: 'string',
  },
  229: {
    id: 229,
    key: 'hide_book_additional_appointment_button',
    default_value: 0,
    category: 'widget',
    type: 'int',
  },
  230: {
    id: 230,
    key: 'saferpay_api_url',
    default_value: 'https://test.saferpay.com/api',
    category: 'payment',
    type: 'string',
  },
  231: {
    id: 231,
    key: 'widget_hide_event_capacity',
    default_value: 0,
    category: 'widget',
    type: 'int',
  },
  232: {
    id: 232,
    key: 'unblu_idp_endpoint_url',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  233: {
    id: 233,
    key: 'use_appointment_specific_custom_field_values',
    default_value: 1,
    category: 'setting',
    type: 'int',
  },
  234: {
    id: 234,
    key: 'scroll_to_element_feature_is_enabled',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  236: {
    id: 236,
    key: 'is_caldav_enabled',
    default_value: '1',
    category: 'dashboard',
    type: 'boolean',
  },
  237: {
    id: 237,
    key: 'widget_internal_comment_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  238: {
    id: 238,
    key: 'widget_internal_comment_shown',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  239: {
    id: 239,
    key: 'widget_company_name_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  240: {
    id: 240,
    key: 'widget_company_name_shown',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  241: {
    id: 241,
    key: 'is_teams_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  242: {
    id: 242,
    key: 'attach_files_in_export_mail',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  243: {
    id: 243,
    key: 'is_store_branding_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  244: {
    id: 244,
    key: 'smartaction_customer_data_export_duration',
    default_value: 0,
    category: 'setting',
    type: 'int'
  },
  245: {
    id: 245,
    key: 'smartaction_appointment_data_export_duration',
    default_value: 0,
    category: 'setting',
    type: 'int'
  },
  246: {
    id: 246,
    key: 'smartaction_group_appointment_data_export_duration',
    default_value: 0,
    category: 'setting',
    type: 'int'
  },
  248: {
    id: 248,
    key: 'is_redirect_after_booking_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  249: {
    id: 249,
    key: 'successful_booking_redirect_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  251: {
    id: 251,
    key: 'is_webhook_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  252: {
    id: 252,
    key: 'is_widget_banner_hint_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  253: {
    id: 253,
    key: 'widget_banner_hint_color',
    default_value: 'danger',
    category: 'setting',
    type: 'string'
  },
  254: {
    id: 254,
    key: 'widget_banner_hint_text',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  255: {
    id: 255,
    key: 'is_appointment_status_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  256: {
    id: 256,
    key: 'mail_appointment_status_customer_is_start',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  257: {
    id: 257,
    key: 'mail_appointment_status_customer_status_change',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  258: {
    id: 258,
    key: 'mail_appointment_status_customer_is_cancellation',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  259: {
    id: 259,
    key: 'mail_appointment_status_customer_is_booking_confirmation',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  260: {
    id: 260,
    key: 'mail_appointment_status_partner_is_start',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  261: {
    id: 261,
    key: 'mail_appointment_status_partner_status_change',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  262: {
    id: 262,
    key: 'mail_appointment_status_partner_is_cancellation',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  263: {
    id: 263,
    key: 'mail_appointment_status_partner_is_booking_confirmation',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  264: {
    id: 264,
    key: 'is_block_other_resource_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  265: {
    id: 265,
    key: 'block_other_resource_mode',
    default_value: 2,
    category: 'setting',
    type: 'int'
  },
  267: {
    id: 267,
    key: 'booking_page_border_radius',
    default_value: '0px',
    category: 'setting',
    type: 'string'
  },
  268: {
    id: 268,
    key: 'booking_page_box_shadow',
    default_value: 'none',
    category: 'setting',
    type: 'string'
  },
  269: {
    id: 269,
    key: 'anyone_feature_hide_ressource',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  274: {
    id: 274,
    key: 'booking_page_primary_color',
    default_value: '#000000',
    category: 'setting',
    type: 'string'
  },
  275: {
    id: 275,
    key: 'booking_page_background_color',
    default_value: '#EBF1FB',
    category: 'setting',
    type: 'string'
  },
  276: {
    id: 276,
    key: 'booking_page_hide_appointment_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  277: {
    id: 277,
    key: 'booking_page_hide_event_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  278: {
    id: 278,
    key: 'booking_page_hide_employee_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  279: {
    id: 279,
    key: 'booking_page_hide_store_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  280: {
    id: 280,
    key: 'booking_page_hide_about_us_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  281: {
    id: 281,
    key: 'booking_page_hide_ratings_tab',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  282: {
    id: 282,
    key: 'dashboard_hide_setup_assistant',
    default_value: '0',
    category: 'dashboard',
    type: 'boolean',
  },
  283: {
    id: 283,
    key: 'is_display_times_in_calendar_enabled',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  284: {
    id: 284,
    key: 'book_another_appointment_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  285: {
    id: 285,
    key: 'widget_title_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  286: {
    id: 286,
    key: 'widget_title_shown',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  287: {
    id: 287,
    key: 'widget_country_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  288: {
    id: 288,
    key: 'widget_country_shown',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  289: {
    id: 289,
    key: 'webhook_strip_html_tags',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  290: {
    id: 290,
    key: 'widget_show_resource_store_name',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  291: {
    id: 291,
    key: 'is_captcha_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  292: {
    id: 292,
    key: 'number_of_resources_in_calendar',
    default_value: 5,
    category: 'setting',
    type: 'int'
  },
  293: {
    id: 293,
    key: 'inform_employees_about_calendar_synchronization_problems',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  294: {
    id: 294,
    key: 'calendar_synchronization_problems_recipients',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  295: {
    id: 295,
    key: 'ignore_workers_without_calendar',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  296: {
    id: 296,
    key: 'is_lexoffice_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  297: {
    id: 297,
    key: 'lexoffice_api_key',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  298: {
    id: 298,
    key: 'block_access_for_supportuser',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  299: {
    id: 299,
    key: 'required_appointment_form_fields',
    default_value: 'resource,start,end,cancellation',
    category: 'setting',
    type: 'string'
  },
  300: {
    id: 300,
    key: 'required_customer_form_fields',
    default_value: 'prename,lastname,resource,notification_type,customer_type',
    category: 'setting',
    type: 'string'
  },
  301: {
    id: 301,
    key: 'is_group_appointment_category_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  302: {
    id: 302,
    key: 'is_group_appointment_store_feature_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  303: {
    id: 303,
    key: 'salesforce_auth_url',
    default_value: null,
    category: 'setting',
    type: 'string'

  },
  304: {
    id: 304,
    key: 'salesforce_client_id',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  305: {
    id: 305,
    key: 'salesforce_client_secret',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  306: {
    id: 306,
    key: 'salesforce_username',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  307: {
    id: 307,
    key: 'salesforce_password',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  308: {
    id: 308,
    key: 'salesforce_api_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  309: {
    id: 309,
    key: 'is_salesforce_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  310: {
    id: 310,
    key: 'is_ldap_sso_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  311: {
    id: 311,
    key: 'ldap_host',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  312: {
    id: 312,
    key: 'ldap_dn',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  313: {
    id: 313,
    key: 'ldap_password',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  314: {
    id: 314,
    key: 'ldap_search_base',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  315: {
    id: 315,
    key: 'widget_mobile_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  316: {
    id: 316,
    key: 'widget_language_polish_hidden',
    default_value: 1,
    category: 'widget',
    type: 'boolean',
  },
  317: {
    id: 317,
    key: 'show_mobile_on_widget',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  318: {
    id: 318,
    key: 'activate_mobile_number_verification_feature',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  319: {
    id: 319,
    key: 'is_widget_event_single_slot_preselect_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  320: {
    id: 320,
    key: 'group_appointments_filter_behaviour',
    default_value: 'or',
    category: 'setting',
    type: 'setting',
  },
  321: {
    id: 321,
    key: 'widget_language_swedish_hidden',
    default_value: 1,
    category: 'widget',
    type: 'boolean',
  },
  322: {
    id: 322,
    key: 'widget_language_spanish_hidden',
    default_value: '1',
    category: 'widget',
    type: 'boolean',
  },
  324: {
    id: 324,
    key: 'show_phone_on_widget',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  325: {
    id: 325,
    key: 'is_exivo_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  326: {
    id: 326,
    key: 'exivo_api_key',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  327: {
    id: 327,
    key: 'exivo_api_secret',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  328: {
    id: 328,
    key: 'is_global_employee_booking_limit_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  329: {
    id: 329,
    key: 'global_employee_booking_limit',
    default_value: 1,
    category: 'setting',
    type: 'string',
  },
  330: {
    id: 330,
    key: 'is_widget_service_shortcut_button_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  331: {
    id: 331,
    key: 'azure_ad_client_id',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  332: {
    id: 332,
    key: 'widget_is_appointment_service_arrow_enabled',
    default_value: '0',
    category: 'widget',
    type: 'boolean',
  },
  333: {
    id: 333,
    key: 'whitelisted_ip_addresses',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  334: {
    id: 334,
    key: 'is_calendly_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  386: {
    id: 386,
    key: 'calendly_client_id',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  387: {
    id: 387,
    key: 'calendly_client_secret',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  336: {
    id: 336,
    key: 'include_city_name_in_postcode_results',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  337: {
    id: 337,
    key: 'is_event_rebooking_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  338: {
    id: 338,
    key: 'is_event_rebooking_reason_optional',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  339: {
    id: 339,
    key: 'is_event_rebooking_reason_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  342: {
    id: 342,
    key: 'is_event_booking_limit_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  343: {
    id: 343,
    key: 'global_event_booking_limit',
    default_value: 2,
    category: 'setting',
    type: 'string',
  },
  344: {
    id: 344,
    key: 'mail_event_booking_reached',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  345: {
    id: 345,
    key: 'widget_show_free_slots_in_overview',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  346: {
    id: 346,
    key: 'booking_page_hide_partner_address',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  347: {
    id: 347,
    key: 'booking_page_ui_mode',
    default_value: 'grid',
    category: 'setting',
    type: 'string'
  },
  348: {
    id: 348,
    key: 'booking_page_hide_switcher',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  349: {
    id: 349,
    key: 'show_mobile_of_worker_on_landingpage',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  350: {
    id: 350,
    key: 'azure_ad_client_secret',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  351: {
    id: 351,
    key: 'azure_ad_tenant_id',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  352: {
    id: 352,
    key: 'office365_client_secret_expiry',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  353: {
    id: 353,
    key: 'inxmail_api_secret_expiry',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  356: {
    id: 356,
    key: 'azure_ad_client_secret_expiry',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  357: {
    id: 357,
    key: 'load_external_calendar_availabilities',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  359: {
    id: 359,
    key: 'widget_show_location_on_appointment_proposal',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  360: {
    id: 360,
    key: 'show_worker_selection_on_date_step',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  363: {
    id: 363,
    key: 'is_availability_and_absence_view_in_calendar_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  364: {
    id: 364,
    key: 'show_widget_slot_location',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  365: {
    id: 365,
    key: 'widget_remove_duplicate_minutes_slots',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  366: {
    id: 366,
    key: 'use_new_dashboard_design',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  367: {
    id: 367,
    key: 'is_workflow_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  368: {
    id: 368,
    key: 'use_custom_email_template',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  369: {
    id: 369,
    key: 'send_email_from_test_systems',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  370: {
    id: 370,
    key: 'default_email_provider',
    default_value: 'brevo',
    category: 'setting',
    type: 'string'
  },
  371: {
    id: 371,
    key: 'smtp_host',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  372: {
    id: 372,
    key: 'smtp_port',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  373: {
    id: 373,
    key: 'smtp_username',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  374: {
    id: 374,
    key: 'smtp_password',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  375: {
    id: 375,
    key: 'smtp_tls',
    default_value: false,
    category: 'setting',
    type: 'boolean'
  },
  376: {
    id: 376,
    key: 'widget_jumps_to_resources_step_when_single_service',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  378: {
    id: 378,
    key: 'is_azure_sync_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  384: {
    id: 384,
    key: 'is_auto_refresh_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  385: {
    id: 385,
    key: 'auto_refresh_interval',
    default_value: 5,
    category: 'setting',
    type: 'int'
  },
  388: {
    id: 388,
    key: 'split_personal_form_and_summary_in_widget',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  389: {
    id: 389,
    key: 'is_appointment_reservation_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  390: {
    id: 390,
    key: 'x_minutes_appointment_reservation',
    default_value: 15,
    category: 'setting',
    type: 'int'
  },
  391: {
    id: 391,
    key: 'show_worker_selection_on_date_step_on_landing_page',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  392: {
    id: 392,
    key: 'swisscom_api_key',
    default_value: null,
    category: 'setting',
    type: 'string',
    requires_verification: 1
  },
  393: {
    id: 393,
    key: 'show_cross_selling_services_on_summary_step',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  394: {
    id: 394,
    key: 'mail_event_registration_guest',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  395: {
    id: 395,
    key: 'mail_event_cancel_guest',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  396: {
    id: 396,
    key: 'is_widget_anyone_exception_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  397: {
    id: 397,
    key: 'is_login_using_email_disabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  398: {
    id: 398,
    key: 'show_widget_calendar_notice',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  399: {
    id: 399,
    key: 'hide_external_calendar_events_in_calendar',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  400: {
    id: 400,
    key: 'is_widget_password_protection_setting_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  401: {
    id: 401,
    key: 'partner_widget_access_password',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  402: {
    id: 402,
    key: 'widget_type_preferences',
    default_value: [WIDGET_APPOINTMENT_TYPE.INTERNAL_APPOINTMENT, WIDGET_APPOINTMENT_TYPE.EXTERNAL_APPOINTMENT, WIDGET_APPOINTMENT_TYPE.EXTERNAL_GROUP_APPOINTMENT, WIDGET_APPOINTMENT_TYPE.EXTERNAL_PRE_DEFINED_SLOTS],
    category: 'setting',
    type: 'string'
  },
  403: {
    id: 403,
    key: 'batch_request_for_office365',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  404: {
    id: 404,
    key: 'redirect_after_booking_action',
    default_value: 'booking_summary_view',
    category: 'setting',
    type: 'string'
  },
  405: {
    id: 405,
    key: 'activate_calendar_reminders',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  407: {
    id: 407,
    key: 'show_unique_stores_based_on_postal_code_mappings',
    default_value: 1,
    category: 'setting',
    type: 'int',
  },
  408: {
    id: 408,
    key: 'widget_birthday_shown',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  409: {
    id: 409,
    key: 'widget_birthday_required',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  410: {
    id: 410,
    key: 'widget_birthday_minimum_age_18',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  411: {
    id: 411,
    key: 'max_appointment_rebooking_limit',
    default_value: 1,
    category: 'setting',
    type: 'int'
  },
  412: {
    id: 412,
    key: 'widget_vat_type',
    default_value: 'inclusive',
    category: 'setting',
    type: 'string'
  },
  413: {
    id: 413,
    key: 'enable_phishing_protection',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  414: {
    id: 414,
    key: 'phishing_protection_regex',
    default_value: '/^(?![sS]*([a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}|https?://S+|www.S+))[sS]*$/',
    category: 'setting',
    type: 'string'
  },
  415: {
    id: 415,
    key: 'reserved_calendar_with_appointment_status_feature',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  416: {
    id: 416,
    key: 'captcha_type',
    default_value: 'calenso_default',
    category: 'setting',
    type: 'string'
  },
  417: {
    id: 417,
    key: 'friendly_captcha_sitekey',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  418: {
    id: 418,
    key: 'friendly_captcha_apikey',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  419: {
    id: 419,
    key: 'widget_protection_type',
    default_value: 'password', // otp, password
    category: 'setting',
    type: 'string'
  },
  420: {
    id: 420,
    key: 'otp_verification_type',
    default_value: 'email', // email, sms
    category: 'setting',
    type: 'string'
  },
  421: {
    id: 421,
    key: 'otp_complexity',
    default_value: 'low', // low, medium, high
    category: 'setting',
    type: 'string'
  },
  422: {
    id: 422,
    key: 'is_customer_authentication_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean'
  },
  423: {
    id: 423,
    key: 'enable_widget_restriction',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  424: {
    id: 424,
    key: 'widget_restriction_parameters',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  425: {
    id: 425,
    key: 'enable_workers_randomize_with_same_time_slots',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  426: {
    id: 426,
    key: 'enable_customer_booking_export',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  427: {
    id: 427,
    key: 'iframe_resizer_version',
    default_value: '4.3.5',
    category: 'setting',
    type: 'string'
  },
  428: {
    id: 428,
    key: 'ics_file_organizer_name',
    default_value: 'partner',
    category: 'setting',
    type: 'string'
  },
  429: {
    id: 429,
    key: 'ics_file_organizer_email',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  430: {
    id: 430,
    key: 'sms_appointment_customer_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  431: {
    id: 431,
    key: 'sms_appointment_customer_multiple_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  432: {
    id: 432,
    key: 'sms_appointment_customer_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  433: {
    id: 433,
    key: 'sms_event_customer_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  434: {
    id: 434,
    key: 'sms_event_customer_multiple_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  435: {
    id: 435,
    key: 'sms_event_customer_cancel_by_partner',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  436: {
    id: 436,
    key: 'sms_event_customer_signoff',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  437: {
    id: 437,
    key: 'sms_event_customer_cancel_by_customer',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  438: {
    id: 438,
    key: 'sms_event_customer_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  439: {
    id: 439,
    key: 'sms_event_customer_waitinglist_switch',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  440: {
    id: 440,
    key: 'sms_event_customer_waitinglist_registration',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  441: {
    id: 441,
    key: 'sms_event_partner_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  442: {
    id: 442,
    key: 'sms_event_customer_multiday_booking',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  443: {
    id: 443,
    key: 'sms_appointment_customer_rebook',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  444: {
    id: 444,
    key: 'sms_event_customer_waitinglist_cancel_by_partner',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  445: {
    id: 445,
    key: 'sms_event_partner_rebook',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  446: {
    id: 446,
    key: 'sms_customer_partner_lead',
    default_value: 1,
    category: 'setting',
    type: 'boolean'
  },
  447: {
    id: 447,
    key: 'calendar_week_start_day',
    default_value: 'monday',
    category: 'setting',
    type: 'string'
  },
  448: {
    id: 448,
    key: 'calendar_default_view',
    default_value: 'week',
    category: 'setting',
    type: 'string'
  },
  449: {
    id: 449,
    key: 'customer_authentication_url',
    default_value: null,
    category: 'setting',
    type: 'string'
  },
  450: {
    id: 450,
    key: 'is_global_service_booking_limit_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  451: {
    id: 451,
    key: 'global_service_limit_duration',
    default_value: 'PER_MONTH',
    category: 'setting',
    type: 'string',
  },
  452: {
    id: 452,
    key: 'global_service_booking_limit',
    default_value: 1,
    category: 'setting',
    type: 'string',
  },
  453: {
    id: 453,
    key: 'global_employee_limit_duration',
    default_value: 'PER_MONTH',
    category: 'setting',
    type: 'string',
  },
  // Microsoft Teams Meeting Settings (IDs 454-462)
  454: {
    id: 454,
    key: 'teams_lobby_bypass_scope',
    default_value: 'organization',
    category: 'teams',
    type: 'string',
  },
  455: {
    id: 455,
    key: 'teams_dial_in_bypass_enabled',
    default_value: '0',
    category: 'teams',
    type: 'boolean',
  },
  456: {
    id: 456,
    key: 'teams_allowed_lobby_admitters',
    default_value: 'organizerAndCoOrganizers',
    category: 'teams',
    type: 'string',
  },
  457: {
    id: 457,
    key: 'teams_entry_exit_announced',
    default_value: '1',
    category: 'teams',
    type: 'boolean',
  },
  458: {
    id: 458,
    key: 'teams_allowed_presenters',
    default_value: 'everyone',
    category: 'teams',
    type: 'string',
  },
  459: {
    id: 459,
    key: 'teams_allow_attendee_mic',
    default_value: '1',
    category: 'teams',
    type: 'boolean',
  },
  460: {
    id: 460,
    key: 'teams_allow_attendee_camera',
    default_value: '1',
    category: 'teams',
    type: 'boolean',
  },
  461: {
    id: 461,
    key: 'teams_allow_meeting_chat',
    default_value: 'enabled',
    category: 'teams',
    type: 'string',
  },
  462: {
    id: 462,
    key: 'teams_allow_reactions',
    default_value: '1',
    category: 'teams',
    type: 'boolean',
  },
  463: {
    id: 463,
    key: 'obfuscate_customer_data_on_landingpages',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  464: {
    id: 464,
    key: 'mail_resource_planning_worker_assigned',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  465: {
    id: 465,
    key: 'mail_resource_planning_worker_unassigned',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  466: {
    id: 466,
    key: 'mail_resource_planning_fully_staffed',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  467: {
    id: 467,
    key: 'mail_resource_planning_staffing_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  468: {
    id: 468,
    key: 'resource_planning_staffing_reminder_days',
    default_value: 3,
    category: 'setting',
    type: 'number',
  },
  480: {
    id: 480,
    key: 'mail_resource_planning_unbooked_reminder',
    default_value: 1,
    category: 'setting',
    type: 'boolean',
  },
  469: {
    id: 469,
    key: 'appointment_list_columns',
    default_value: '["resource","date","title","services","customer","location","price"]',
    category: 'dashboard',
    type: 'string',
  },
  470: {
    id: 470,
    key: 'is_dynamic_combi_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  471: {
    id: 471,
    key: 'dynamic_combi_max_duration_minutes',
    default_value: 180,
    category: 'setting',
    type: 'number',
  },
  472: {
    id: 472,
    key: 'dynamic_combi_travel_time_mode',
    default_value: 'followup',
    category: 'setting',
    type: 'string',
  },
  473: {
    id: 473,
    key: 'is_hubspot_enabled',
    default_value: 0,
    category: 'hubspot',
    type: 'boolean',
  },
  474: {
    id: 474,
    key: 'hubspot_client_id',
    default_value: null,
    category: 'hubspot',
    type: 'string',
  },
  475: {
    id: 475,
    key: 'hubspot_client_secret',
    default_value: null,
    category: 'hubspot',
    type: 'string',
  },
  476: {
    id: 476,
    key: 'hubspot_sync_contacts',
    default_value: 0,
    category: 'hubspot',
    type: 'boolean',
  },
  477: {
    id: 477,
    key: 'hubspot_sync_companies',
    default_value: 0,
    category: 'hubspot',
    type: 'boolean',
  },
  478: {
    id: 478,
    key: 'hubspot_sync_appointments',
    default_value: 0,
    category: 'hubspot',
    type: 'boolean',
  },
  479: {
    id: 479,
    key: 'hubspot_default_owner_id',
    default_value: null,
    category: 'hubspot',
    type: 'string',
  },
  484: {
    id: 484,
    key: 'ms_graph_email_sender_address',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  485: {
    id: 485,
    key: 'ms_graph_tenant_id',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  486: {
    id: 486,
    key: 'ms_graph_client_id',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  487: {
    id: 487,
    key: 'ms_graph_client_secret',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  488: {
    id: 488,
    key: 'ms_graph_client_secret_expiry',
    default_value: null,
    category: 'setting',
    type: 'string',
  },
  489: {
    id: 489,
    key: 'use_native_teams_calendar_event',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  490: {
    id: 490,
    key: 'webex_enabled_join_before_host',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  491: {
    id: 491,
    key: 'webex_join_before_host_minutes',
    default_value: '0',
    category: 'webex',
    type: 'string',
  },
  492: {
    id: 492,
    key: 'webex_enable_connect_audio_before_host',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  493: {
    id: 493,
    key: 'webex_allow_any_user_to_be_co_host',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  494: {
    id: 494,
    key: 'webex_allow_first_user_to_be_co_host',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  495: {
    id: 495,
    key: 'webex_enabled_auto_record_meeting',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  496: {
    id: 496,
    key: 'webex_send_email',
    default_value: '0',
    category: 'webex',
    type: 'boolean',
  },
  497: {
    id: 497,
    key: 'customer_list_columns',
    default_value: '["created","worker","name","address","phone","email"]',
    category: 'dashboard',
    type: 'string',
  },
  498: {
    id: 498,
    key: 'is_waitinglist_auto_refund_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  499: {
    id: 499,
    key: 'graph_api_logging_is_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  500: {
    id: 500,
    key: 'otp_restricted_components',
    default_value: 'appointment_booking',
    category: 'setting',
    type: 'string'
  },
  501: {
    id: 501,
    key: 'ics_file_add_attendee',
    default_value: 0,
    category: 'setting',
    type: 'boolean'
  },
  502: {
    id: 502,
    key: 'ics_file_method',
    default_value: 'PUBLISH',
    category: 'setting',
    type: 'string'
  },
  503: {
    id: 503,
    key: 'is_stripe_appointment_payment_enabled',
    default_value: 0,
    category: 'stripe',
    type: 'boolean',
  },
  504: {
    id: 504,
    key: 'is_stripe_event_payment_enabled',
    default_value: 0,
    category: 'stripe',
    type: 'boolean',
  },
  505: {
    id: 505,
    key: 'widget_time_format',
    default_value: 'auto',
    category: 'widget',
    type: 'string',
  },
  506: {
    id: 506,
    key: 'is_zip_codes_search_enabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  507: {
    id: 507,
    key: 'is_gtm_enabled',
    default_value: 0,
    category: 'analytics-integration',
    type: 'boolean',
  },
  508: {
    id: 508,
    key: 'tour_upcoming_absences_window_days',
    default_value: 90,
    category: 'widget',
    type: 'number',
  },
  509: {
    id: 509,
    key: 'cross_selling_services_category_filter',
    default_value: 0,
    category: 'widget',
    type: 'integer',
  },
  511: {
    id: 511,
    key: 'widget_display_timezone_source',
    default_value: 'visitor',
    category: 'widget',
    type: 'string',
  },
  519: {
    id: 519,
    key: 'twilio_account_sid',
    default_value: '',
    category: 'setting',
    type: 'string',
  },
  520: {
    id: 520,
    key: 'twilio_auth_token',
    default_value: '',
    category: 'setting',
    type: 'string',
  },
  521: {
    id: 521,
    key: 'twilio_from_number',
    default_value: '',
    category: 'setting',
    type: 'string',
  },
  522: {
    id: 522,
    key: 'sendgrid_api_key',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  523: {
    id: 523,
    key: 'sendgrid_webhook_verification_key',
    default_value: null,
    category: 'email',
    type: 'string',
  },
  526: {
    id: 526,
    key: 'azure_sso_login_identifier',
    default_value: 'email',
    category: 'setting',
    type: 'string',
  },
  543: {
    id: 543,
    key: 'queue_sla_target_seconds',
    default_value: 300,
    category: 'queue_sla',
    type: 'integer',
  },
  544: {
    id: 544,
    key: 'queue_sla_max_seconds',
    default_value: 900,
    category: 'queue_sla',
    type: 'integer',
  },
  545: {
    id: 545,
    key: 'queue_retention_days',
    default_value: 1,
    category: 'queue',
    type: 'integer',
  },
  546: {
    id: 546,
    key: 'queue_mode',
    default_value: 'counter_only',
    category: 'queue',
    type: 'string',
  },
  // IDs 547-553 reserved for the legacy queue notification toggles
  // (queue_notifications_enabled / queue_sms_* / queue_email_*). Replaced by the
  // workflow-based pipeline (partners configure SMS / email through
  // /app/workflows). The Phase D backend migration drops the master `settings`
  // rows + orphan `partners_settings` data.
  554: {
    id: 554,
    key: 'queue_kiosk_capture_phone',
    default_value: 'optional',
    category: 'queue_kiosk',
    type: 'string',
  },
  555: {
    id: 555,
    key: 'queue_kiosk_consent_text_key',
    default_value: 'queue_kiosk_default_consent',
    category: 'queue_kiosk',
    type: 'string',
  },
  556: {
    id: 556,
    key: 'queue_qr_target',
    default_value: 'mobile_position',
    category: 'queue_qr',
    type: 'string',
  },
  557: {
    id: 557,
    key: 'queue_qr_show_on_print',
    default_value: 1,
    category: 'queue_qr',
    type: 'boolean',
  },
  558: {
    id: 558,
    key: 'queue_qr_show_on_screen',
    default_value: 1,
    category: 'queue_qr',
    type: 'boolean',
  },
  559: {
    id: 559,
    key: 'queue_appt_auto_enroll',
    default_value: 1,
    category: 'queue_appointment',
    type: 'boolean',
  },
  560: {
    id: 560,
    key: 'queue_appt_enroll_window_minutes',
    default_value: 15,
    category: 'queue_appointment',
    type: 'integer',
  },
  561: {
    id: 561,
    key: 'queue_appt_require_checkin',
    default_value: 0,
    category: 'queue_appointment',
    type: 'boolean',
  },
  562: {
    id: 562,
    key: 'queue_appt_inherit_customer_data',
    default_value: 1,
    category: 'queue_appointment',
    type: 'boolean',
  },
  563: {
    id: 563,
    key: 'queue_sla_service_target_seconds',
    default_value: 600,
    category: 'queue_sla',
    type: 'integer',
  },
  564: {
    id: 564,
    key: 'queue_sla_service_max_seconds',
    default_value: 1800,
    category: 'queue_sla',
    type: 'integer',
  },
  565: {
    id: 565,
    key: 'queue_sla_recall_target_seconds',
    default_value: 30,
    category: 'queue_sla',
    type: 'integer',
  },
  566: {
    id: 566,
    key: 'queue_sla_recall_max_seconds',
    default_value: 120,
    category: 'queue_sla',
    type: 'integer',
  },
  567: {
    id: 567,
    key: 'queue_sla_help_dismissed',
    default_value: 0,
    category: 'queue_sla',
    type: 'boolean',
  },
  568: {
    id: 568,
    key: 'enable_round_robin_v2',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  569: {
    id: 569,
    key: 'round_robin_default_algorithm',
    default_value: 'first_available',
    category: 'setting',
    type: 'string',
  },
  570: {
    id: 570,
    key: 'round_robin_apply_on_rebooking',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  571: {
    id: 571,
    key: 'round_robin_v2_channel_scope',
    default_value: 'smart_widget,booking_widget,booking_link,internal_widget,api',
    category: 'setting',
    type: 'string',
  },
  572: {
    id: 572,
    key: 'widget_buttons_always_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  573: {
    id: 573,
    key: 'meeting_type_selection_ui_mode',
    default_value: 'dropdown',
    category: 'setting',
    type: 'string',
  },
  574: {
    id: 574,
    key: 'enable_multi_store_workers',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  575: {
    id: 575,
    key: 'mark_on_site_appointment_paid_by_default',
    default_value: 0,
    category: 'online_payment',
    type: 'int',
  },
  576: {
    id: 576,
    key: 'ics_file_employee_method',
    default_value: 'PUBLISH',
    category: 'setting',
    type: 'string'
  },
  577: {
    id: 577,
    key: 'booking_page_hide_from_search_engines',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  578: {
    id: 578,
    key: 'is_scim_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  // Resource-Forecast absence vocabulary (JB-1798) — JSON per absence kind.
  // The default here mirrors the export-service classifier's built-in
  // multilingual table and is the SOURCE the keyword dialog pre-fills from —
  // the cakephp SettingsSeed row deliberately keeps default_value EMPTY
  // (settings.default_value is varchar(400), too small for this JSON).
  579: {
    id: 579,
    key: 'forecast_absence_keywords',
    default_value: '{"sick":["sick","krank","malade","maladie","malato","malattia","ziek","sairas","chory","enfermo","sjuk"],"accident":["unfall","accident","infortunio","ongeval","tapaturma","wypadek","accidente","olycka","olycksfall"],"holiday":["ferien","urlaub","holiday","holidays","vacation","vacances","congé","conge","vacanze","ferie","vakantie","verlof","loma","urlop","vacaciones","semester","ledighet"],"absent":["abwesend","abwesenheit","absence","absent","afwezig","poissa","nieobecny","ausente","frånvarande","out of office","ooo","oof"]}',
    category: 'setting',
    type: 'string',
  },
  583: {
    id: 583,
    key: 'default_payment_type',
    default_value: '',
    category: 'online_payment',
    type: 'string',
  },
  585: {
    id: 585,
    key: 'is_azure_sync_teams_auto_connect_enabled',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  586: {
    id: 586,
    key: 'is_admin_appointment_rebooking_disabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  587: {
    id: 587,
    key: 'is_admin_event_rebooking_disabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  588: {
    id: 588,
    key: 'is_admin_cancellation_disabled',
    default_value: 0,
    category: 'setting',
    type: 'boolean',
  },
  // Store hierarchy (parent/child stores) — own add-on + this per-partner kill switch, same
  // shape as 574 `enable_multi_store_workers`. Mirrors the cakephp SettingsSeed row (id 589 —
  // 580 was surrendered to JB-1565's Adyen setting, and 586-588 went to JB-1803).
  589: {
    id: 589,
    key: 'enable_store_hierarchy',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
  // Standalone "Invoice" payment mode — enable/disable the widget's Invoice
  // payment mode, no Bexio/lexOffice integration required.
  590: {
    id: 590,
    key: 'is_external_invoice_appointment_payment_enabled',
    default_value: 0,
    category: 'online_payment',
    type: 'boolean',
  },
  591: {
    id: 591,
    key: 'kmeet_start_audio_muted',
    default_value: '1',
    category: 'kmeet',
    type: 'boolean',
  },
  592: {
    id: 592,
    key: 'kmeet_start_audio_only',
    default_value: '0',
    category: 'kmeet',
    type: 'boolean',
  },
  593: {
    id: 593,
    key: 'kmeet_enable_moderator_video',
    default_value: '1',
    category: 'kmeet',
    type: 'boolean',
  },
  594: {
    id: 594,
    key: 'kmeet_lobby_enabled',
    default_value: '0',
    category: 'kmeet',
    type: 'boolean',
  },
  595: {
    id: 595,
    key: 'kmeet_password_enabled',
    default_value: '0',
    category: 'kmeet',
    type: 'boolean',
  },
  596: {
    id: 596,
    key: 'kmeet_e2ee_enabled',
    default_value: '0',
    category: 'kmeet',
    type: 'boolean',
  },
  606: {
    id: 606,
    key: 'is_azure_sso_mapped_group_required',
    default_value: '0',
    category: 'setting',
    type: 'boolean',
  },
};
